import { render, staticRenderFns } from "./lecture-category-select.vue?vue&type=template&id=4d0ac3d0"
import script from "./lecture-category-select.vue?vue&type=script&lang=js"
export * from "./lecture-category-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports